import { getPlaceholderFromConnectionState } from '../helpers/get-placeholder-from-connection-state.helper';
export default class TokboxSpectatorStream {
    constructor(personConnection) {
        this.personConnection = personConnection;
        this.hasAudio = false;
        this.hasVideo = false;
        this.type = 'spectator';
        this.volumeLevel = 0;
        this.videoElement = null;
        this.videoElementPromise = Promise.resolve(null);
    }
    get isWaiting() {
        return !this.placeholder;
    }
    get id() {
        return this.personConnection.id;
    }
    getImgData() {
        return '';
    }
    getVideoElement() {
        return null;
    }
    destroy() { }
    async getStats() {
        return { audio: null, video: null };
    }
    get placeholder() {
        return getPlaceholderFromConnectionState(this.personConnection.state);
    }
}
